import GenericBadge from 'components/ui/Badge';
import { GenericColors } from 'enums/genericColors';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { NsKey } from 'enums/NsKey';

/**
 * Badge "Complété" affiché à droite des sections quand le contrat est verrouillé
 * (au moins un mandat SEPA signé OU contrat finalisé). Réutilise le même style
 * `GenericBadge` que les badges d'état des `LightContractCard`.
 */
export const LockBadge = () => {
  const { t } = useDynamicTranslation([NsKey.Contract]);
  return (
    <GenericBadge
      color={GenericColors.Green}
      label={t('GROUP_CONTRACT_PROCESS.LOCK_BADGE')}
      badgeType="status"
    />
  );
};
